import { Box, Theme, Typography, useTheme } from '@mui/material';

import { styles } from '../../styles';

export const Avatar = ({ name }: { name: string }) => {
  const theme = useTheme();
  return (
    <Box
      sx={[
        styles.listItemImageSize,
        {
          borderRadius: '50%',
          backgroundColor: getAvatarColorForName(name, theme),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      ]}>
      <Typography variant="h2" sx={{ color: 'text.contrast' }}>
        {name.charAt(0)}
      </Typography>
    </Box>
  );
};

const getAvatarColorForName = (name: string, theme: Theme) => {
  const sumOfInitialCharacterCodes = name
    .split('')
    .reduce((acc, name) => acc + name.charCodeAt(0), 0);

  const avatarsPalette = Object.values(theme.palette.content);
  return avatarsPalette[sumOfInitialCharacterCodes % avatarsPalette.length];
};
